module.exports = __webpack_public_path__ + "img/lang-33.753a34f6.jpg";